// Utility functions for barcode scanning and camera management

export const isPhone = () => {
  const ua = navigator.userAgent;
  // More precise mobile detection
  return /Android|iPhone|iPad|iPod|Mobi|Mobile/i.test(ua) && !/Tablet|PlayBook|Silk/i.test(ua);
};

export const convertToGrayscale = (imageData: any) => {
  const data = imageData.data;
  for (let i = 0; i < data.length; i += 4) {
    const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
    data[i] = avg;
    data[i + 1] = avg;
    data[i + 2] = avg;
  }
  return imageData;
};

export const getMediaConstraints = async (facingMode: string) => {
  console.log('[CAMERA DEBUG] getMediaConstraints called with facingMode:', facingMode);
  console.log('[CAMERA DEBUG] UserAgent:', navigator.userAgent);
  console.log('[CAMERA DEBUG] Is phone?', isPhone());

  // Simplified constraints that work across all devices
  const constraints = {
    audio: false,
    video: {
      facingMode: facingMode,
      width: { ideal: 1280 },
      height: { ideal: 720 },
    },
  };

  console.log('[CAMERA DEBUG] Constraints:', JSON.stringify(constraints, null, 2));
  return constraints;
};

export const stopAllTracks = (stream: any) => {
  if (stream) {
    const tracks = stream.getTracks();
    for (const track of tracks) {
      track.stop();
    }
  }
};
